// Staff Mutations

export const updateStaffList = (state, payload) => {
  state.staffList = payload
}

export const fetchStaffMemberInfo = (state, payload) => {
  state.staffMemberInfo = payload
}

export const fetchStaffMemberSubOutlet = (state, payload) => {
  state.staffMemberSubOutlet = payload
}

export const updatePermissionsList = (state, payload) => {
  state.allPermissionsList = payload
}

export const setFullStaffsList = (state, payload) => {
  state.fullStaffsList = payload
}

export const setFullOutletStaffsList = (state, payload) => {
  state.fullOutletStaffsList = payload
}
